import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import { FaUser, FaUserTie, FaUserCheck } from 'react-icons/fa';
import './UploadAvatar.css'; // Your custom styles
import logoImage from './NRDRUHSLogo.png'; // Import the logo image
import NRDRUHSHeader from './NRDRUHSHeader'
import NRDRUHSFooter from './NRDRUHSFooter';

function ISSNPage() {
    const [showMenu, setShowMenu] = useState(false);
    const [scrolling, setScrolling] = useState(false);

    const toggleMenu = () => {
        setShowMenu(prev => !prev);
    };

    useEffect(() => {
        const handleScroll = () => {
            setScrolling(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div>
            {/* NAVBAR */}
            <nav className={`navBar ${scrolling ? 'scrolling' : ''}`} data-aos="fade-down" data-aos-duration="1200">
                {/* Logo Image */}
                <img src={logoImage} alt="Logo" className="logo" />

                {/* Hamburger Menu Button */}
                <div className="menuButton" onClick={toggleMenu}>
                    <div className={`menuIcon ${showMenu ? 'open' : ''}`} />
                </div>

                {/* Navigation Links */}
                <ul className={`navLinks ${showMenu ? 'show' : ''}`}>
                    <li><Link to="/" className="link">Home</Link></li>
                    <li><Link to="/aboutus" className="link">About NRD</Link></li>
                    <li><Link to="/issnpage" className="link">ISSN</Link></li>
                    <li><Link to="/editorialboard" className="link">Editorial Board</Link></li>
                    <li><Link to="#" className="link">Current Issues</Link></li>
                    <li><Link to="/publications" className="link">Publications</Link></li>

                    <NavDropdown title="Login" id="basic-nav-dropdown" style={{ fontWeight: 'bold' }}>
                        <NavDropdown.Item href="/login">
                            <FaUser style={{ marginRight: 6, color: 'Navy' }} /> Author
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/reviewlogin">
                            <FaUserTie style={{ marginRight: 6, color: 'Chocolate' }} /> Reviewer
                        </NavDropdown.Item>
                        <NavDropdown.Item href="/adminlogin">
                            <FaUserCheck style={{ marginRight: 6, color: 'green' }} /> Admin
                        </NavDropdown.Item>
                    </NavDropdown>
                </ul>

                {/* Register Dropdown */}
                <NavDropdown title="Register" id="register-dropdown" style={{ fontWeight: 'bold', marginRight: 18, backgroundColor: 'red', padding: 15 }}>
                    <NavDropdown.Item href="/register">
                        <FaUser style={{ marginRight: 6, color: 'Navy' }} /> As an Author
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/registerreviewer">
                        <FaUserTie style={{ marginRight: 6, color: 'red' }} /> As a Reviewer
                    </NavDropdown.Item>
                </NavDropdown>
            </nav>

            <NRDRUHSHeader />

            {/* ISSN Content */}
            <div className="container" style={{ paddingTop: 90 }}>
                <h2 className="text-center mb-4" style={{ fontWeight: 'bold' }}>NRD RUHS - ISSN</h2>
            </div>

            <div className="container">
                <div className="row" style={{ marginBottom: 120 }}>
                    <div className="col-md-2" style={{ padding: 30 }}></div>

                    <div className="col-md-8" style={{ padding: 15, textAlign: 'center' }}>
                        <p style={{ textAlign: 'center', lineHeight: 2.1 }}>
                            <b >National Research Denticon – ISSN Print 2395-6844</b><br /><br />
                           
                            <br /><br /><br /><br />
                        </p>
                    </div>

                    <div className="col-md-2" style={{ padding: 15 }}></div>
                </div>
            </div>

            <NRDRUHSFooter />
        </div>
    );
}

export default ISSNPage;
